<template>
  <div class="card-content">
    <div class="mt-s">
      <div v-if="version == 4">
        <Version4 :data="data" />
      </div>

      <div v-if="version == 5">
        <Version5 :data="data" />
      </div>
    </div>
  </div>
</template>

<script>
import Version4 from "@components/Dashboard/Views/Pages/Training/Record/Components/Version4";
import Version5 from "@components/Dashboard/Views/Pages/Training/Record/Components/Version5";

export default {
  components: {
    Version4,
    Version5,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    version: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {

    };
  },
  computed: {

  },
  methods: {

  },
};
</script>

<style lang="scss"></style>
